import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXXL, spaceL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const ContentPlaceholder = styled.div`
  min-height: 50vh;
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;
